import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import Components
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

// Import Pages
import Home from './pages/Home';
import Services from './pages/Services';
import SingleService from './pages/SingleService';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Resources from './pages/Resources';
import ResourceLanding from './pages/ResourceLanding';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';

function App() {
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        
        {/* Main Content Area */}
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<SingleService />} /> {/* Dynamic routing for specific services */}
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:id" element={<ResourceLanding />} /> {/* Dynamic routing for specific whitepapers */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>

        <Footer />
        
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;